import React, { Component } from 'react'
import NotFoundPage from '../../../pages/404'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error('Error caught in ErrorBoundary:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      // Render the 404 component directly
      return <NotFoundPage />
    }

    return this.props.children
  }
}

export default ErrorBoundary
